import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgStar = (props) => /* @__PURE__ */ _jsx("svg", {
	"data-icon": "star",
	width: 22,
	height: 22,
	viewBox: "0 0 22 22",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M11 1.48901L14.09 7.75101L21 8.75501L16 13.629L17.18 20.511L11 17.261L4.82 20.511L6 13.629L1 8.75501L7.91 7.75101L11 1.48901Z",
		stroke: "#B6BBC4",
		strokeWidth: 1.5,
		strokeMiterlimit: 10,
		strokeLinecap: "square",
		strokeLinejoin: "round"
	})
});
export default SvgStar;
